export default "__VITE_ASSET__CtUnFj1R__"